/** Default copy written into empty note editors. It is not a note. */
const PLACEHOLDER_NOTES = new Set([
  "no summary available yet",
  "no notes available yet",
  "no day type notes available yet",
  "no technique notes available yet",
  "no winning notes available yet",
]);

/** Visible text of a note field, with tags and extra space removed. */
export function notePlainText(html: string | null | undefined): string {
  if (html == null) {
    return "";
  }
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();
}

function normalizeNoteCompare(text: string): string {
  return text.replace(/\s+/g, " ").trim().toLowerCase().replace(/\.+$/, "");
}

export function isPlaceholderNote(text: string): boolean {
  const normalized = normalizeNoteCompare(text);
  return normalized === "" || PLACEHOLDER_NOTES.has(normalized);
}

/**
 * A note section counts when it is real writing.
 * Empty editor placeholders do not count, and neither does the dataset description.
 */
export function isMeaningfulNoteSection(
  html: string | null | undefined,
  description?: string | null
): boolean {
  const text = notePlainText(html);
  if (text.length <= 30 || isPlaceholderNote(text)) {
    return false;
  }
  const descriptionText = notePlainText(description);
  if (descriptionText !== "" && normalizeNoteCompare(text) === normalizeNoteCompare(descriptionText)) {
    return false;
  }
  return true;
}

export function notesHaveMeaningfulContent(
  sections: readonly (string | null | undefined)[],
  description?: string | null
): boolean {
  return sections.some((section) => isMeaningfulNoteSection(section, description));
}
